// extracted by mini-css-extract-plugin
export default {"requirement":"UploadDocumentRequirements_requirement__ylh6W","checkedIcon":"UploadDocumentRequirements_checkedIcon__4xv-c"};